import { PurchaseCardsGroup } from '@components'

import React, { ReactElement } from 'react'

import { useBackToSchoolCampaign } from '@features/backToSchoolCampaign/hooks/useBackToSchoolCampaign'
import { SubscriptionPeriod } from '@modules-deprecated/app/organization/enums/subscriptionPeriod'
import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'

import { useOrganizationMarket } from '../../../../../../hooks'
import { PlanSelectionContextProvider } from './contexts/planSelectionContext'
import { CompletePlanCard } from './elements/CompletePlanCard'
import { FreePlanCard } from './elements/FreePlanCard'
import { StandardPaidPlanCard } from './elements/StandardPaidPlanCard'
import { useShouldDisplayPlan } from './hooks/useShouldDisplayPlan'
import * as Styled from './styles'

interface SubscriptionPlansProps {
  onPlanSelect: (plan: SubscriptionPlan, period?: SubscriptionPeriod) => void
}

export const SubscriptionPlans = ({ onPlanSelect }: SubscriptionPlansProps): ReactElement => {
  const { isCampaignActive } = useBackToSchoolCampaign()
  const {
    shouldDisplayFreePlan,
    shouldDisplayBasicPlan,
    shouldDisplayStartPlan,
    shouldDisplayPlusPlan,
    shouldDisplayCompletePlan,
  } = useShouldDisplayPlan()

  const { market } = useOrganizationMarket()

  return (
    <PlanSelectionContextProvider isMonthlyPeriodForced={isCampaignActive} onPlanSelect={onPlanSelect}>
      <Styled.SubscriptionPlansWrapper>
        <PurchaseCardsGroup>
          {shouldDisplayBasicPlan && <StandardPaidPlanCard plan={SubscriptionPlan.BasicPaid} market={market} />}
          {shouldDisplayStartPlan && <StandardPaidPlanCard plan={SubscriptionPlan.Start} market={market} />}
          {shouldDisplayPlusPlan && <StandardPaidPlanCard plan={SubscriptionPlan.Plus} market={market} />}
          {shouldDisplayCompletePlan && <CompletePlanCard plan={SubscriptionPlan.Complete} />}
        </PurchaseCardsGroup>
        {shouldDisplayFreePlan && <FreePlanCard plan={SubscriptionPlan.Free} market={market} />}
      </Styled.SubscriptionPlansWrapper>
    </PlanSelectionContextProvider>
  )
}
